import { useState, useEffect } from 'react';

const LOGO_URL = 'https://static.readdy.ai/image/8c1d21b01113fd26c1c387000dbd0877/176183260277585ae8c6af0fe7bc7559.png';

interface NavbarProps {
  onContactClick: () => void;
}

export default function Navbar({ onContactClick }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-gray-100' : 'bg-white/90 border-b border-gray-100'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-18 flex items-center justify-between" style={{ height: '72px' }}>
        {/* Logo */}
        <button onClick={() => scrollTo('hero')} className="flex items-center gap-3 cursor-pointer whitespace-nowrap">
          <img
            src={LOGO_URL}
            alt="신진패키징 로고"
            className="h-12 w-auto object-contain flex-shrink-0"
          />
          <div className="flex flex-col justify-center gap-2">
            <span
              className="font-black leading-none tracking-[0.18em]"
              style={{ color: '#0A508C', fontSize: '22px' }}
            >
              신진패키징
            </span>
            <span
              className="font-medium leading-none text-gray-400"
              style={{ fontSize: '9px', letterSpacing: '0.05em' }}
            >
              XINJIN PACK&amp;DESIGN.Co
            </span>
          </div>
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: '서비스', id: 'services' },
            { label: '고객 유형', id: 'customer-type' },
            { label: '제품 구매', id: 'smartstore' },
            { label: '진행 방식', id: 'process' },
            { label: '사례', id: 'cases' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-base font-medium transition-colors cursor-pointer whitespace-nowrap text-gray-700 hover:text-[#0A508C]"
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://smartstore.naver.com"
            target="_blank"
            rel="nofollow noreferrer"
            className="text-base font-semibold px-4 py-2 rounded-lg border transition-all cursor-pointer whitespace-nowrap border-[#2BC0D0] text-[#2BC0D0] hover:bg-[#2BC0D0]/10"
          >
            스마트스토어
          </a>
          <button
            onClick={onContactClick}
            className="text-base font-semibold px-4 py-2 rounded-lg text-white cursor-pointer whitespace-nowrap transition-opacity hover:opacity-90"
            style={{ background: 'linear-gradient(135deg, #0A508C, #3A7CC0)' }}
          >
            상담 문의
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl text-gray-800 ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-3">
          {[
            { label: '서비스', id: 'services' },
            { label: '고객 유형', id: 'customer-type' },
            { label: '제품 구매', id: 'smartstore' },
            { label: '진행 방식', id: 'process' },
            { label: '사례', id: 'cases' },
          ].map((item) => (
            <button key={item.id} onClick={() => scrollTo(item.id)} className="text-base text-gray-700 font-medium text-left cursor-pointer py-1 whitespace-nowrap">
              {item.label}
            </button>
          ))}
          <div className="flex gap-2 mt-2">
            <a href="https://smartstore.naver.com" target="_blank" rel="nofollow noreferrer" className="flex-1 text-center text-base font-semibold px-4 py-2 rounded-lg border border-[#2BC0D0] text-[#2BC0D0] cursor-pointer whitespace-nowrap">스마트스토어</a>
            <button onClick={onContactClick} className="flex-1 text-base font-semibold px-4 py-2 rounded-lg text-white cursor-pointer whitespace-nowrap" style={{ background: 'linear-gradient(135deg, #0A508C, #3A7CC0)' }}>상담 문의</button>
          </div>
        </div>
      )}
    </nav>
  );
}
